import React, { PureComponent } from 'react';
import styles from './styles.scss';

import HourPairDiscountItem from './HourPairDiscountItem';

class WeekDayDiscountsListItem extends PureComponent {
  render() {
    return (
      <tr>
        <td className="text-center">
          <input type="checkbox" checked={this.props.hasDiscountInWeekday} disabled={true} />
        </td>
        <td className="text-center">{this.props.title}</td>
        <td className={styles.weekdayHoursListContainer}>
          <ul className={styles.weekdayHoursList}>
            {this.props.hourlyDiscounts &&
              this.props.hourlyDiscounts.length &&
              this.props.hourlyDiscounts.map(x => (
                <HourPairDiscountItem
                  key={x.itemKey}
                  weekday={this.props.weekday}
                  itemKey={x.itemKey}
                  fromTime={x.fromTime}
                  toTime={x.toTime}
                  discountValue={x.discountValue}
                  discountType={x.discountType}
                  hasDiscount={x.hasDiscount}
                  onChangeDiscountValue={this.props.onChangeDiscountValue}
                  onChangeHasDiscount={this.props.onChangeHasDiscount}
                  onChangeDiscountType={this.props.onChangeDiscountType}
                />
              ))}
          </ul>
        </td>
      </tr>
    );
  }
}

export default WeekDayDiscountsListItem;
